
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.224 10.98a.98.98 0 0 1-.33-.055.763.763 0 0 1-.285-.188L3.444 7.573a.807.807 0 0 1-.253-.616.923.923 0 0 1 .253-.615.895.895 0 0 1 .627-.274.819.819 0 0 1 .626.252l1.648 1.648V1.683c0-.25.084-.458.253-.626a.855.855 0 0 1 .626-.253c.249 0 .457.084.627.253.17.17.253.378.252.626v6.285L9.751 6.32a.82.82 0 0 1 .627-.253.89.89 0 0 1 .626.275c.161.176.246.38.253.615a.803.803 0 0 1-.253.616L7.84 10.737a.777.777 0 0 1-.285.188.952.952 0 0 1-.33.054zM1.95 14.868c-.484 0-.898-.172-1.242-.516a1.696 1.696 0 0 1-.517-1.242v-1.758c0-.25.085-.458.254-.626a.855.855 0 0 1 .625-.253.844.844 0 0 1 .627.253c.17.17.254.378.253.626v1.758h10.549v-1.758c0-.25.084-.458.253-.626a.855.855 0 0 1 .626-.253.843.843 0 0 1 .626.253c.17.17.254.378.253.626v1.758c0 .483-.172.897-.516 1.242a1.689 1.689 0 0 1-1.242.516H1.948z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M7.224 10.98a.98.98 0 0 1-.33-.055.763.763 0 0 1-.285-.188L3.444 7.573a.807.807 0 0 1-.253-.616.923.923 0 0 1 .253-.615.895.895 0 0 1 .627-.274.819.819 0 0 1 .626.252l1.648 1.648V1.683c0-.25.084-.458.253-.626a.855.855 0 0 1 .626-.253c.249 0 .457.084.627.253.17.17.253.378.252.626v6.285L9.751 6.32a.82.82 0 0 1 .627-.253.89.89 0 0 1 .626.275c.161.176.246.38.253.615a.803.803 0 0 1-.253.616L7.84 10.737a.777.777 0 0 1-.285.188.952.952 0 0 1-.33.054zM1.95 14.868c-.484 0-.898-.172-1.242-.516a1.696 1.696 0 0 1-.517-1.242v-1.758c0-.25.085-.458.254-.626a.855.855 0 0 1 .625-.253c.249-.001.458.083.627.253.17.17.254.378.253.626v1.758h10.549v-1.758c0-.25.084-.458.253-.626a.855.855 0 0 1 .626-.253c.248-.001.457.083.626.253.17.17.254.378.253.626v1.758c0 .483-.172.897-.516 1.242a1.689 1.689 0 0 1-1.242.516H1.948z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/download.0e2078781b20f2c870eddab2f66efd9f.svg"),
        {
          React: SvgDownload,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      